// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_ctx";

function createInitialWrkPrecalcData(preCtxVer, parenStr, varsText, disjText, hyps) {
  return {
          preCtxVer: preCtxVer,
          preCtx: undefined,
          wrkFrms: undefined,
          parenStr: parenStr,
          wrkParenInts: undefined,
          wrkParenCnt: undefined,
          varsText: varsText,
          disjText: disjText,
          hyps: hyps,
          wrkCtx: undefined
        };
}

var wrkPrecalcData = {
  contents: createInitialWrkPrecalcData(-1, "", "", "", [])
};

function getWrkCtxExn(param) {
  var wrkCtx = wrkPrecalcData.contents.wrkCtx;
  if (wrkCtx !== undefined) {
    return Caml_option.valFromOption(wrkCtx);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkCtx is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkParenCntExn(param) {
  var wrkParenCnt = wrkPrecalcData.contents.wrkParenCnt;
  if (wrkParenCnt !== undefined) {
    return Caml_option.valFromOption(wrkParenCnt);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkParenCnt is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkFrmsExn(param) {
  var wrkFrms = wrkPrecalcData.contents.wrkFrms;
  if (wrkFrms !== undefined) {
    return Caml_option.valFromOption(wrkFrms);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "wrkFrms is not created in the worker thread."
        },
        Error: new Error()
      };
}

var preCtxCache = Common.cacheMake((function (ctx) {
        return [
                ctx,
                MM_substitution.prepareFrmSubsData(ctx)
              ];
      }), (function (preCtxV1, preCtxV2) {
        return preCtxV1 === preCtxV2;
      }));

function prepareParenInts(wrkCtx, parenStr) {
  var parenSyms = MM_parser.getSpaceSeparatedValuesAsArray(parenStr);
  var parenInts = [];
  var maxI = (parenSyms.length / 2 | 0) - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var leftParen = Caml_array.get(parenSyms, (i << 1));
    var rightParen = Caml_array.get(parenSyms, (i << 1) + 1 | 0);
    var leftParenInt = MM_context.ctxSymToInt(wrkCtx, leftParen);
    if (leftParenInt !== undefined && MM_context.isConst(wrkCtx, leftParen)) {
      var rightParenInt = MM_context.ctxSymToInt(wrkCtx, rightParen);
      if (rightParenInt !== undefined && MM_context.isConst(wrkCtx, rightParen)) {
        parenInts.push(leftParenInt);
        parenInts.push(rightParenInt);
      }
      
    }
    
  }
  return parenInts;
}

var newLineRegex = /[\n\r]/;

function createWrkCtx(preCtx, varsText, disjText, hyps) {
  var wrkCtx = MM_context.createContext(Caml_option.some(preCtx), undefined, undefined);
  var err = [
      (function (param) {
          var varLines = varsText.split(newLineRegex).map(function (so) {
                  return Belt_Option.getWithDefault(so, "").trim();
                }).filter(function (s) {
                return s.length > 0;
              });
          if (varLines.length === 0) {
            return ;
          }
          try {
            varLines.forEach(function (param) {
                  var arr = MM_parser.getSpaceSeparatedValuesAsArray(param);
                  if (arr.length !== 3) {
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "Cannot convert '" + param + "' to Var statement."
                          },
                          Error: new Error()
                        };
                  }
                  MM_context.applySingleStmt(wrkCtx, {
                        TAG: /* Var */3,
                        symbols: [Caml_array.get(arr, 2)]
                      });
                  return MM_context.applySingleStmt(wrkCtx, {
                              TAG: /* Floating */5,
                              label: Caml_array.get(arr, 0),
                              expr: [
                                Caml_array.get(arr, 1),
                                Caml_array.get(arr, 2)
                              ]
                            });
                });
            return ;
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === MM_parser.MmException) {
              return {
                      varsErr: exn._1.msg,
                      disjErr: undefined,
                      hypErr: undefined
                    };
            }
            throw exn;
          }
        }),
      (function (param) {
          var disjLines = disjText.split(newLineRegex).map(function (so) {
                  return Belt_Option.getWithDefault(so, "").trim();
                }).filter(function (s) {
                return s.length > 0;
              });
          try {
            disjLines.forEach(function (param) {
                  return MM_context.applySingleStmt(wrkCtx, {
                              TAG: /* Disj */4,
                              vars: param.split(",").map(function (prim) {
                                    return prim.trim();
                                  })
                            });
                });
            return ;
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === MM_parser.MmException) {
              return {
                      varsErr: undefined,
                      disjErr: exn._1.msg,
                      hypErr: undefined
                    };
            }
            throw exn;
          }
        }),
      (function (param) {
          return hyps.reduce((function (err, stmt) {
                        if (err !== undefined) {
                          return err;
                        } else {
                          try {
                            MM_context.applySingleStmt(wrkCtx, {
                                  TAG: /* Essential */6,
                                  label: stmt.label,
                                  expr: MM_parser.getSpaceSeparatedValuesAsArray(stmt.text)
                                });
                            return ;
                          }
                          catch (raw_exn){
                            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                            if (exn.RE_EXN_ID === MM_parser.MmException) {
                              return {
                                      varsErr: undefined,
                                      disjErr: undefined,
                                      hypErr: [
                                        stmt.id,
                                        exn._1.msg
                                      ]
                                    };
                            }
                            throw exn;
                          }
                        }
                      }), undefined);
        })
    ].reduce((function (err, nextStep) {
          if (err !== undefined) {
            return err;
          } else {
            return Curry._1(nextStep, undefined);
          }
        }), undefined);
  if (err !== undefined) {
    return {
            TAG: /* Error */1,
            _0: err
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: wrkCtx
          };
  }
}

function updateWrkPrecalcData(_wrkPrecalcData) {
  while(true) {
    var wrkPrecalcData = _wrkPrecalcData;
    var preCtx = wrkPrecalcData.preCtx;
    if (preCtx !== undefined) {
      var wrkCtx = createWrkCtx(Caml_option.valFromOption(preCtx), wrkPrecalcData.varsText, wrkPrecalcData.disjText, wrkPrecalcData.hyps);
      if (wrkCtx.TAG === /* Ok */0) {
        var wrkCtx$1 = wrkCtx._0;
        var parenInts = prepareParenInts(wrkCtx$1, wrkPrecalcData.parenStr);
        return {
                preCtxVer: wrkPrecalcData.preCtxVer,
                preCtx: wrkPrecalcData.preCtx,
                wrkFrms: wrkPrecalcData.wrkFrms,
                parenStr: wrkPrecalcData.parenStr,
                wrkParenInts: parenInts,
                wrkParenCnt: Caml_option.some(MM_parenCounter.parenCntMake(parenInts, undefined, undefined)),
                varsText: wrkPrecalcData.varsText,
                disjText: wrkPrecalcData.disjText,
                hyps: wrkPrecalcData.hyps,
                wrkCtx: Caml_option.some(wrkCtx$1)
              };
      }
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "There was an error creating wrkCtx in the worker thread."
            },
            Error: new Error()
          };
    }
    var match = Common.cacheGetByDepVer(preCtxCache, wrkPrecalcData.preCtxVer);
    if (match === undefined) {
      return wrkPrecalcData;
    }
    _wrkPrecalcData = {
      preCtxVer: wrkPrecalcData.preCtxVer,
      preCtx: Caml_option.some(match[0]),
      wrkFrms: Caml_option.some(match[1]),
      parenStr: wrkPrecalcData.parenStr,
      wrkParenInts: wrkPrecalcData.wrkParenInts,
      wrkParenCnt: wrkPrecalcData.wrkParenCnt,
      varsText: wrkPrecalcData.varsText,
      disjText: wrkPrecalcData.disjText,
      hyps: wrkPrecalcData.hyps,
      wrkCtx: wrkPrecalcData.wrkCtx
    };
    continue ;
  };
}

function processOnWorkerSide(req, sendToClient) {
  if (req.TAG === /* PrepareWrkPrecalcData */0) {
    wrkPrecalcData.contents = createInitialWrkPrecalcData(req.preCtxVer, req.parenStr, req.varsText, req.disjText, req.hyps);
  } else {
    Common.cacheGet(preCtxCache, req.preCtxVer, req.preCtx);
  }
  wrkPrecalcData.contents = updateWrkPrecalcData(wrkPrecalcData.contents);
  var match = wrkPrecalcData.contents.preCtx;
  if (match === undefined) {
    return Curry._1(sendToClient, /* GetPreCtx */{
                preCtxVer: wrkPrecalcData.contents.preCtxVer
              });
  }
  var match$1 = wrkPrecalcData.contents.wrkCtx;
  if (match$1 !== undefined) {
    return Curry._1(sendToClient, /* Ok */0);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Could not create wrkCtx in the worker thread."
        },
        Error: new Error()
      };
}

function beginWorkerInteractionUsingCtx(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, procName$1, initialRequest, onResponse, enableTraceOpt, param) {
  var enableTrace = enableTraceOpt !== undefined ? enableTraceOpt : false;
  MM_wrk_client.beginWorkerInteraction(procName, {
        TAG: /* PrepareWrkPrecalcData */0,
        preCtxVer: preCtxVer,
        parenStr: parenStr,
        varsText: varsText,
        disjText: disjText,
        hyps: hyps
      }, (function (resp, sendToWorker, endWorkerInteraction) {
          if (resp) {
            if (resp.preCtxVer === preCtxVer) {
              return Curry._1(sendToWorker, {
                          TAG: /* SetPreCtx */1,
                          preCtxVer: preCtxVer,
                          preCtx: preCtx
                        });
            } else {
              return ;
            }
          } else {
            Curry._1(endWorkerInteraction, undefined);
            return MM_wrk_client.beginWorkerInteraction(procName$1, initialRequest, onResponse, enableTrace, undefined);
          }
        }), enableTrace, undefined);
}

exports.procName = procName;
exports.getWrkCtxExn = getWrkCtxExn;
exports.getWrkParenCntExn = getWrkParenCntExn;
exports.getWrkFrmsExn = getWrkFrmsExn;
exports.prepareParenInts = prepareParenInts;
exports.createWrkCtx = createWrkCtx;
exports.processOnWorkerSide = processOnWorkerSide;
exports.beginWorkerInteractionUsingCtx = beginWorkerInteractionUsingCtx;
/* wrkPrecalcData Not a pure module */
